var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.253 10.61l3.536 3.536L13.646 28.29l-3.535-3.536 14.142-14.142zm-4.95-4.949l3.536 3.536L8.697 23.339 5.16 19.803 19.303 5.661zm-4.95-4.95l3.536 3.536-9.192 9.192L5.16 9.904 14.354.71zM3.748 11.318l3.535 3.536-3.535 3.535-3.536-3.535 3.536-3.536z",
    fill: "#FAB800",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "static/media/busd.2da89fe0495f77b4d79b3d3f1874fdb1.svg";
export { SvgBusd as ReactComponent };